/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_External_Booking_Edit_Customize_Email_NotificationInputs */

const en_admin_external_booking_edit_customize_email_notification = /** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can customize the email notification that will be sent.`)
};

const de_admin_external_booking_edit_customize_email_notification = /** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst die E-Mail-Benachrichtigung anpassen, die gesendet wird.`)
};

const es_admin_external_booking_edit_customize_email_notification = /** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes personalizar la notificación por correo electrónico que se enviará.`)
};

const fr_admin_external_booking_edit_customize_email_notification = /** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez personnaliser la notification e-mail qui sera envoyée.`)
};

/** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */
const it_admin_external_booking_edit_customize_email_notification = en_admin_external_booking_edit_customize_email_notification;

/** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */
const pt_br2_admin_external_booking_edit_customize_email_notification = en_admin_external_booking_edit_customize_email_notification;

/** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */
const pl_admin_external_booking_edit_customize_email_notification = en_admin_external_booking_edit_customize_email_notification;

/** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */
const hu_admin_external_booking_edit_customize_email_notification = en_admin_external_booking_edit_customize_email_notification;

/** @type {(inputs: Admin_External_Booking_Edit_Customize_Email_NotificationInputs) => LocalizedString} */
const ro_admin_external_booking_edit_customize_email_notification = en_admin_external_booking_edit_customize_email_notification;

/**
* | output |
* | --- |
* | "You can customize the email notification that will be sent." |
*
* @param {Admin_External_Booking_Edit_Customize_Email_NotificationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_external_booking_edit_customize_email_notification = /** @type {((inputs?: Admin_External_Booking_Edit_Customize_Email_NotificationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_External_Booking_Edit_Customize_Email_NotificationInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "de") return de_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "es") return es_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "fr") return fr_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "it") return it_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "pt-BR") return pt_br2_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "pl") return pl_admin_external_booking_edit_customize_email_notification(inputs)
	if (locale === "hu") return hu_admin_external_booking_edit_customize_email_notification(inputs)
	return ro_admin_external_booking_edit_customize_email_notification(inputs)
});
export { admin_external_booking_edit_customize_email_notification as "admin.external_booking_edit.customize_email_notification" }